import React from 'react'
import CustomText from './CustomText'
import { DatePicker, TimePicker } from 'antd'
import * as locCon from "../LocalConstants"
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import dayjs from 'dayjs';
import { StateStoredValue } from '../hooks/StoreHooks';
import { nowInStudyLocation, timeNowInStudyLocation } from '../community-hats-js-library/utils/dateFunctions'
import { CheckboxDefaultValue } from './CustomCheckBox';

export function SimpleDatePickerFromId({ valueID, ...props }) {

    const [value, setValue] = StateStoredValue(valueID)

    return (<SimpleDatePicker value={value} setValue={setValue} {...props} />)
}



export function SimpleDatePicker({ value, setValue, title, infoText, includeCheckbox = false, defaultValue = null, checkboxText = null, dateFormat = 'YYYY-MM-DD', usePlaceholder = false, placeholder = null }) {

    const isUnset = isNullOrUndefined(value) || value === defaultValue

    const pickerValue = isUnset
        ? (usePlaceholder ? null : dayjs(nowInStudyLocation(false)))
        : dayjs(value)

    return (
        <div className="verticalSection">
            {title !== null ? <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{title}</CustomText> : <div></div>}
            {infoText !== null ? <CustomText type={locCon.INFO_TEXT}>{infoText}</CustomText> : <div></div>}
            <DatePicker inputReadOnly allowClear={false} style={{ marginBottom: "1vh" }} onChange={(d) => setValue(d ? d.format(dateFormat) : null)} value={pickerValue} placeholder={placeholder} format={dateFormat} />
            {includeCheckbox ? <CheckboxDefaultValue value={value} setValue={setValue} defaultValue={defaultValue} text={checkboxText} /> : <div></div>}
        </div>
    )
}

export function SimpleTimePickerFromId({ valueID, ...props }) {

    const [value, setValue] = StateStoredValue(valueID)

    return (<SimpleTimePicker inputReadOnly value={value} setValue={setValue} {...props} />)
}


export function SimpleTimePicker({ value, setValue, title, infoText }) {

    const FORMAT = 'HH:mm'

    return (
        <div className="verticalSection">
            {title !== null ? <CustomText type={locCon.ELEMENT_TITLE_TEXT}>{title}</CustomText> : <div></div>}
            {infoText !== null ? <CustomText type={locCon.INFO_TEXT}>{infoText}</CustomText> : <div></div>}
            <TimePicker allowClear={false} style={{ marginBottom: "1vh" }} onChange={(time) => setValue(time.format(FORMAT))} value={isNullOrUndefined(value) ? dayjs(timeNowInStudyLocation(false), "HH:mm") : dayjs(value, "HH:mm")} format={"HH:mm"} />
        </div>
    )
}



